module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d087f19974a4c1d3d2a080189e719387.png";